import { FC, HtmlHTMLAttributes } from "react";

import { CircularProgress } from "@mui/material";

import styles from "./styles.module.scss";

type Props = HtmlHTMLAttributes<HTMLButtonElement> & {
    className?: string;
    size?: "sx" | "newSmall" | "small" | "medium" | "large";
    variant?: "primary" | "primary_outlined" | "secondary" | "tertiary" | "transparent" | "outlined";
    label?: string;
    disabled?: boolean;
    labelOptions?: {
        align?: "left" | "center" | "right";
        noWrap?: boolean;
    };
    onClick?: Function | undefined;
    Icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
    LeftIcon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
    isLoading?: boolean;
    iconSize?: number;
}

const Button: FC<Props> = ({
    className,
    size = "large",
    variant = "primary",
    label,
    onClick,
    Icon,
    LeftIcon,
    isLoading = false,
    labelOptions,
    children,
    iconSize,
    disabled = false,
}) => {
    let props: any = { disabled };
    if (onClick && !isLoading && !disabled) {
        props.onClick = onClick;
    }

    let iconProps: any = {};
    if (iconSize) {
        iconProps.style = { width: iconSize, height: iconSize };
    }

    return (
        <button
            className={`${className} ${styles.button} ${
                styles[`button_${variant}`]
            } ${styles[`button_${size}`]} ${
                styles[`button_content_${labelOptions?.align || "center"}`]
            } ${disabled ? styles.button_disabled : ""}`}
            {...props}
        >
            {isLoading ? (
                <CircularProgress size={20} color="inherit" />
            ) : (
                <>
                    {Icon && <Icon {...iconProps} />}
                    {(label || children) && (
                        <div
                            className={`${
                                labelOptions?.noWrap
                                    ? styles.button_label_nowrap
                                    : ""
                            }`}
                        >
                            {label || children}
                        </div>
                    )}
                    {LeftIcon && <LeftIcon {...iconProps} />}
                </>
            )}
        </button>
    );
};

export default Button;
